<template>
  <div class="news-slider">
    <swiper :options="sliderOptions">
      <swiper-slide v-for="(val, i) in newsList" :key="`newsslider-${ i }`">
        <CardNews
          :title="val.name"
          :photo="val.image"
          :excerpt="val.subName"
          :date="val.date"
          @click="$router.push(`/news/${ val.id }`)"
        />
      </swiper-slide>
      <div slot="pagination" class="swiper-pagination" />
      <div slot="button-prev" class="swiper-button-prev" />
      <div slot="button-next" class="swiper-button-next" />
    </swiper>
  </div>
</template>

<script>
import CardNews from '@/components/page/CardNews'
import _ from 'lodash'

export default {
  components: { CardNews },
  props: {
    sliderOptions: {
      type: Object,
      default () {
        return {
          slidesPerView: 3,
          spaceBetween: 27,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            768: {
              slidesPerView: 3,
              pagination: { el: null },
            },
            378: {
              slidesPerView: 2,
            },
            0: {
              slidesPerView: 1,
              pagination: { el: '.swiper-pagination' },
            },
          },
        }
      },
    },
    news: {
      type: Array,
      default () {
        return []
      },
    },
    currentId: {
      type: Number,
      default () {
        return 0
      },
    },
  },
  computed: {
    newsList () {
      if (this.currentId > 0) {
        return _.reject(this.news, (element) => {
          return element.id === this.currentId
        })
      }

      return this.news
    },
  },
}
</script>

<style lang="less">
.news-slider {
	width: 100%;
	display: flex;

	.swiper {
		&-container {
			width: 100%;
			padding-top: 10px;
			padding-bottom: 60px;
			margin-top: -10px;
			margin-bottom: -30px;
		}

		&-wrapper {
			height: auto;
		}

		&-slide {
			height: auto;
			border-radius: 30px;
			box-shadow: 0 17px 46px -14px rgba(0, 0, 0, .15);
			overflow: hidden;

			.card-news { height: 100%; }
		}

		&-pagination {
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translateX(-50%);

			&-bullet {
				width: 13px;
				height: 7px;
				background-color: #DEDEDE;
				border-radius: 20px;
				transition: width .3s;

				&:not(:last-child) {
					margin-right: 7px;
				}

				&-active {
					width: 28px;
					background-color: #003CFF;
				}
			}
		}

		&-button-prev, &-button-next {
			color: #003CFF;
			opacity: 0;
			transition: all .3s;
		}
	}
}
</style>
